<template>
	<button
		class="am-hamburger"
		:class="{
			'is-active': value
		}"
		@click="$emit('input', !value)"
	>
		<span class="am-hamburger__line am-hamburger__line--top"></span>
		<span class="am-hamburger__line am-hamburger__line--mid"></span>
		<span class="am-hamburger__line am-hamburger__line--bot"></span>
	</button>
</template>

<script>
export default {
	props: {
		value: {
			type: Boolean,
			default: false
		}
	}
}
</script>

<style lang="scss">
.am-hamburger{
	width: 44px;
	height: 44px;
	background: transparent;
	border: 0;
	cursor: pointer;
	outline: none;
	position: relative;
	padding: 0;
	&__line{
		position: absolute;
		left: 12px;
		height: 1px;
		right: 12px;
		border-radius: 4px;
		background: #99887F;
		transition: .4s $easeInOutQuad;
		&--top{
			top: 12px;
		}
		&--mid{
			top: 50%;
		}
		&--bot{
			bottom: 11px;
		}
	}
	&.is-active{
		.am-hamburger{
			&__line{
				transition: .4s $easeOutBack;
				&--top{
					top: 50%;
					transform: rotate(135deg);
				}
				&--mid{
					top: 50%;
					transform: rotate(225deg);
				}
				&--bot{
					bottom: 21px;
					left: 50%;
					right: 50%;
					opacity: 0;
					transform: rotate(135deg);
				}
			}
		}
	}
}
</style>
